// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="popupSecurityCodeHeading">Card Security Code</h1>
        </div>
        <div class="hoa-dialog__main">
            <div class="u-pH6 u-pB4">
                <?xml version="1.0" encoding="utf-8"?>
                <!-- Generator: Adobe Illustrator 20.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     x="0px" y="0px"
                     viewBox="0 0 154.5 90.4" class="helper-svg ccv-helper" xml:space="preserve">
                        <path class="st0"
                              d="M7.4,2.8h140c2.8,0,5,2.2,5,5v75c0,2.8-2.2,5-5,5H7.4c-2.8,0-5-2.2-5-5v-75C2.4,5,4.6,2.8,7.4,2.8z"/>
                    <line class="st1" x1="9.8" y1="78.8" x2="37.4" y2="78.8"/>
                    <path class="st2" d="M12.8,41.3h104.3c1.7,0,3,1.3,3,3v13.1c0,1.7-1.3,3-3,3H12.8c-1.7,0-3-1.3-3-3V44.3
                C9.8,42.6,11.1,41.3,12.8,41.3z"/>
                    <path class="st3" d="M26.2,48c1.2-0.5,3.3-1.9,6.6-2.2c3.3-0.4-0.4,5-0.9,5.8c-1.6,2.4-3.3,4.9-4.4,6.2c-1.5,1.9-2.2,3.3-4.3,4.6
                c-0.9,0.5-4.5,1.5-4.5-2.4c0.1-4.5,8.8-7.1,10.2-7.2s9.2-1.7,8.7,2.2c-0.2,1.5-3.1,3.6-4.4,2.8c-2-1.1,0.7-3.5,1.3-4.1
                c0.4-0.5,5.7-4.7,6.5-5.2c1.7-1.2,3.6-2.2,3.5-0.2c-0.1,1.9-4.2,7.7-5.4,9.4c0.9-1.3,5.4-5.3,6.4-4.6c1,0.7-1.6,4-1.5,4.9
                c0.9,0.2,11.7-9.4,7.1-0.3c-0.9,1.8,13.2-6.3,22-3.1c7,2.5,4.6,3.4,13.3,2"/>
                    <rect x="2.4" y="17.3" class="st4" width="150" height="14.8"/>
                    <g>
                            <path class="st5" d="M126.3,41.2v9.2h16.9v-9.2H126.3z"/>
                        </g>
                    <g>
                            <path class="st4" d="M132.3,45.7c0,1.5-0.6,2.4-1.6,2.4c-0.9,0-1.5-0.8-1.5-2.3s0.7-2.4,1.6-2.4C131.8,43.4,132.3,44.3,132.3,45.7z
                 M129.9,45.8c0,1.2,0.4,1.8,0.9,1.8c0.6,0,0.9-0.7,0.9-1.9c0-1.1-0.3-1.8-0.9-1.8C130.3,43.9,129.9,44.6,129.9,45.8z"/>
                        <path class="st4" d="M136.3,45.7c0,1.5-0.6,2.4-1.6,2.4c-0.9,0-1.5-0.8-1.5-2.3s0.7-2.4,1.6-2.4S136.3,44.3,136.3,45.7z
                 M133.8,45.8c0,1.2,0.4,1.8,0.9,1.8c0.6,0,0.9-0.7,0.9-1.9c0-1.1-0.3-1.8-0.9-1.8C134.2,43.9,133.8,44.6,133.8,45.8z"/>
                        <path class="st4" d="M140.2,45.7c0,1.5-0.6,2.4-1.6,2.4c-0.9,0-1.5-0.8-1.5-2.3s0.7-2.4,1.6-2.4C139.6,43.4,140.2,44.3,140.2,45.7z
                 M137.7,45.8c0,1.2,0.4,1.8,0.9,1.8c0.6,0,0.9-0.7,0.9-1.9c0-1.1-0.3-1.8-0.9-1.8C138.1,43.9,137.7,44.6,137.7,45.8z"/>
                        </g>
                    </svg>
            </div>

            <p tid="popupSecurityCodeParagraph">
                The security code can be located on the back of your card near the signature line. The set of
                digits, highlighted in the sample, are typically the security code.
            </p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130" tid="closeCCVHelper"
                    (click)="closeDialog(0)">Close
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;